import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-primary/15 bg-surface/40 py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxnlqbmowbh">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop7i3vv55lx">I {totalBonuses} <span className="text-accent" data-id="element-21" data-mp="15pw3d22guqyf">Bonus Esclusivi</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-primary/20 bg-background/55 shadow-lg shadow-black/30 backdrop-blur-md" data-id="element-22" data-mp="1jgr39ouzlxpv">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-primary/10 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="qzojqj0q31w5" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-primary/40 bg-surface/60 text-primary" data-id="element-24" data-mp="2jiegjtxv5evs">
                  <Icon className="h-5 w-5 drop-shadow-glow" aria-hidden="true" data-id="element-25" data-mp="1qth0lxh4ju67" />
                </span>
                <div data-id="element-26" data-mp="1vrs9a4vonymu">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-accent" data-id="element-27" data-mp="1vtd2nr69hbj4">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-extrabold uppercase leading-tight text-foreground" data-id="element-28" data-mp="20ptryop75vxs">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-29" data-mp="25oesyqc9wjna">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-accent bg-background/70 px-6 py-6 text-center shadow-lg shadow-black/40 backdrop-blur-md sm:flex-row sm:text-left" data-id="element-30" data-mp="3h4lisx6p2v4z">
          <div data-id="element-31" data-mp="1c42fz5lic43l">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-32" data-mp="1c6olz0sr2bjp">Valore di tutti i {totalBonuses} bonus</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-accent decoration-2" data-id="element-33" data-mp="1m2row8vfee7p">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-34" data-mp="tdt3n2w0avy6">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-35" data-mp="tevrt31y2kae">Il tuo prezzo oggi</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-accent" data-id="element-36" data-mp="1760xomvwo8t6">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-37" data-mp="12cy2697kipac" /> GRATIS
            </p>
          </div>
        </div>
      </div>
    </section>;
}